import React from 'react';
import WorkspacePanelContainer from './WorkspacePanelContainer';

const WorkspacePanelNarrow = ({ code, workspaceUrl }) => (
  <WorkspacePanelContainer
    className="aridhia-workspace-panel-narrow overflow-x-hidden panel-wizardible"
    code={code}
    compact
    url={workspaceUrl}
  />
);

export default WorkspacePanelNarrow;
